<p-toast />
<p-confirmdialog />


<div class="ps-page">

  <!-- Page Header -->
  <div class="ps-header">
    <h2 class="ps-title">Project Information</h2>

    @if (project) {
      <div class="ps-actions">
        <button class="ps-btn-outline" type="button" (click)="leaveProject()">
          <i class="ri-logout-box-line"></i>
          Leave Project
        </button>
        @if (canArchive) {
          <button class="ps-btn-outline ps-btn-danger" type="button" (click)="archiveProject()">
            <i class="ri-archive-line"></i>
            {{ archiveLabel }}
          </button>
        }
        @if (canEdit) {
          <button class="ps-btn-primary" type="button" [disabled]="isSavingLeads" (click)="saveProjectLeads()">
            <i class="ri-save-line"></i>
            {{ isSavingLeads ? 'Saving…' : 'Save' }}
          </button>
        }
      </div>
    }
  </div>

  <!-- Content -->
  @if (!canView) {
    <div class="ps-empty">
      <i class="ri-lock-line"></i>
      <p>You don't have permission to view project settings.</p>
    </div>
  } @else if (!project) {
    <div class="ps-empty">
      <i class="ri-loader-4-line"></i>
      <p>Loading project information...</p>
    </div>
  } @else {
    <div class="ps-card">
      <div class="ps-card-header">
        <span class="ps-card-title">General</span>
        <div class="ps-card-header-actions">
          @if (canArchive) {
            <p-toggleswitch
              [(ngModel)]="isProjectActive"
              (onChange)="onStatusToggle($event)" />
          }
          <span class="ps-status-label" [class.ps-status-inactive]="!isProjectActive">
            {{ isProjectActive ? 'Active' : 'Inactive' }}
          </span>
          <!-- @if (backupFailed) {
            <i class="ri-error-warning-fill ps-backup-icon ps-backup-icon--error"
               pTooltip="Backup failed — contact administrator"
               tooltipPosition="top"></i>
          } -->
        </div>
      </div>
      <div class="ps-form">

        <div class="ps-field">
          <label class="ps-label">Project Name</label>
          <div class="ps-value">{{ project.projectName || '—' }}</div>
        </div>

        <div class="ps-field">
          <label class="ps-label">Project Code</label>
          <div class="ps-value">{{ project.projectNumber || '—' }}</div>
        </div>

        <div class="ps-field">
          <label class="ps-label">Address</label>
          <div class="ps-value">{{ project.customerAddress1 || '—' }}</div>
        </div>

        <div class="ps-field">
          <label class="ps-label">Site Manager</label>
          <select class="ps-select" [(ngModel)]="selectedSiteManagerId" [disabled]="!canEdit">
            <option [ngValue]="null">— Select —</option>
            @for (user of projectUsers; track user.userId) {
              <option [ngValue]="user.userId">{{ user.firstName }} {{ user.lastName }}</option>
            }
          </select>
        </div>

        <div class="ps-field">
          <label class="ps-label">Field Lead</label>
          <select class="ps-select" [(ngModel)]="selectedFieldLeadId" [disabled]="!canEdit">
            <option [ngValue]="null">— Select —</option>
            @for (user of projectUsers; track user.userId) {
              <option [ngValue]="user.userId">{{ user.firstName }} {{ user.lastName }}</option>
            }
          </select>
        </div>

        <div class="ps-field">
          <label class="ps-label">Site Contact</label>
          <input class="ps-input" type="text" [(ngModel)]="siteContact" maxlength="100" placeholder="Site contact name" [disabled]="!canEdit" />
        </div>

        <div class="ps-field">
          <label class="ps-label">Customer Contact</label>
          <input class="ps-input" type="tel" [(ngModel)]="customerContactNumber" maxlength="50" placeholder="Contact number" [disabled]="!canEdit" />
        </div>

        <div class="ps-field">
          <label class="ps-label">Customer Email</label>
          <input class="ps-input" type="email" [(ngModel)]="customerEmailAddress" maxlength="200" placeholder="Email address" [disabled]="!canEdit" />
        </div>

        <div class="ps-field ps-field--full ps-field--tall">
          <label class="ps-label">Additional Information</label>
          <p-editor [(ngModel)]="managerNotes" [style]="{ height: '100%', flex: '1' }" placeholder="Enter any additional notes or information about this project..." [readonly]="!canEdit"></p-editor>
        </div>

        @if (false) {
        <div class="ps-field">
          <label class="ps-label">Inverter Test Report</label>
          <input class="ps-input" type="text" [(ngModel)]="inverterTestReportPath" placeholder="\\server\share\InverterReports" [disabled]="!canEdit" />
        </div>

        <div class="ps-field">
          <label class="ps-label">Inverter Report Destination</label>
          <div class="ps-backup-path-row">
            <select class="ps-select" [(ngModel)]="inverterTestReportSource" style="flex:1" [disabled]="!canEdit">
              <option [ngValue]="null">— Select Destination —</option>
              @for (folder of projectFolders; track folder.fileFolderId) {
                <option [ngValue]="folder.fileFolderId">{{ folder.folderName }}</option>
              }
            </select>
            <!-- @if (isSyncingInverterReports) {
              <i class="ri-hourglass-fill ps-backup-icon ps-backup-icon--progress" pTooltip="Syncing inverter reports..." tooltipPosition="top"></i>
            } @else if (canEdit) {
              <button class="ps-btn-outline ps-btn-outline--sm" type="button" (click)="syncInverterReports()">
                <i class="ri-refresh-line"></i>
                Sync
              </button>
            } -->
          </div>
        </div>

        <div class="ps-field">
          <label class="ps-label">Transformer Test Report</label>
          <input class="ps-input" type="text" [(ngModel)]="transformerTestReportPath" placeholder="\\server\share\TransformerReports" [disabled]="!canEdit" />
        </div>

        <div class="ps-field">
          <label class="ps-label">Transformer Report Destination</label>
          <select class="ps-select" [(ngModel)]="transformerTestReportSource" [disabled]="!canEdit">
            <option [ngValue]="null">— Select Destination —</option>
            @for (folder of projectFolders; track folder.fileFolderId) {
              <option [ngValue]="folder.fileFolderId">{{ folder.folderName }}</option>
            }
          </select>
        </div>
        }

        <div class="ps-field ps-field--half">
          <label class="ps-label">Contract or PO #</label>
          <input class="ps-input" type="text" [(ngModel)]="contractPo" maxlength="100" placeholder="Contract or PO number" [disabled]="!canEdit" />
        </div>

        <div class="ps-field ps-field--half">
          <label class="ps-label">PWA Site Indicator</label>
          <div class="ps-toggle-row">
            <p-toggleswitch [(ngModel)]="isPwaSite" [disabled]="!canEdit" />
            <span class="ps-status-label">{{ isPwaSite ? 'Yes' : 'No' }}</span>
          </div>
        </div>

        <!-- <div class="ps-field ps-field--half">
          <label class="ps-label">Backup Folder Path</label>
          <div class="ps-backup-path-row">
            <input
              class="ps-input"
              [class.ps-input--error]="backupPathRequired"
              type="text"
              [(ngModel)]="backupFolderPath"
              placeholder="e.g. \\server\Navigator-Backups\SiteA"
              [disabled]="!canEdit"
              (ngModelChange)="backupPathRequired = false" />
            @if (isBackupInProgress) {
              <i class="ri-hourglass-fill ps-backup-icon ps-backup-icon--progress"
                 pTooltip="Backup in progress — {{ backupProgress.filesProcessed }}/{{ backupProgress.totalFiles }} files"
                 tooltipPosition="top"></i>
            } @else if (canEdit) {
              <button class="ps-btn-outline ps-btn-outline--sm" type="button" (click)="onResync()">
                <i class="ri-refresh-line"></i>
                Sync
              </button>
            }
          </div>
          @if (backupPathRequired) {
            <span class="ps-field-error">Backup folder path is required.</span>
          }
        </div> -->

      </div>
    </div>

    <!-- Warranty & Map Row -->
    <div class="ps-bottom-row">
      <div class="ps-card ps-warranty-card">
        <div class="ps-card-header">
          <span class="ps-card-title">Warranty &amp; Contract</span>
        </div>
        <table class="ps-warranty-table">
          <thead>
            <tr>
              <th></th>
              <th>Duration (Months)</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="ps-warranty-row-label">Warranty Inverter</td>
              <td class="ps-warranty-duration">{{ inverterDurationMonths !== null ? inverterDurationMonths : '—' }}</td>
              <td><input class="ps-input ps-input--sm" type="date" [(ngModel)]="warrantyInverterStartDate" [disabled]="!canEdit" /></td>
              <td><input class="ps-input ps-input--sm" type="date" [(ngModel)]="warrantyInverterEndDate" [disabled]="!canEdit" /></td>
            </tr>
            <tr>
              <td class="ps-warranty-row-label">Warranty Transformer</td>
              <td class="ps-warranty-duration">{{ transformerDurationMonths !== null ? transformerDurationMonths : '—' }}</td>
              <td><input class="ps-input ps-input--sm" type="date" [(ngModel)]="warrantyTransformerStartDate" [disabled]="!canEdit" /></td>
              <td><input class="ps-input ps-input--sm" type="date" [(ngModel)]="warrantyTransformerEndDate" [disabled]="!canEdit" /></td>
            </tr>
            <tr>
              <td class="ps-warranty-row-label">Warranty MV Power Station</td>
              <td class="ps-warranty-duration">{{ skidDurationMonths !== null ? skidDurationMonths : '—' }}</td>
              <td><input class="ps-input ps-input--sm" type="date" [(ngModel)]="warrantySkidStartDate" [disabled]="!canEdit" /></td>
              <td><input class="ps-input ps-input--sm" type="date" [(ngModel)]="warrantySkidEndDate" [disabled]="!canEdit" /></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ps-map-card">
        <div class="ps-card-header">
          <span class="ps-card-title">Project Location</span>
        </div>
        @if (project.latitude && project.longitude) {
          <button class="ps-map-expand-btn" type="button" (click)="openMapPopup()" title="Expand map">
            <i class="ri-fullscreen-line"></i>
          </button>
          <div #settingsMap class="ps-map-container"></div>
        } @else {
          <div class="ps-map-empty">
            <i class="ri-map-pin-off-line"></i>
            <p>No location coordinates set.</p>
          </div>
        }
      </div>
    </div>

    <!-- Map Popup Overlay -->
    @if (showMapPopup) {
      <div class="ps-map-overlay" (click)="closeMapPopup()">
        <div class="ps-map-popup" (click)="$event.stopPropagation()">
          <div class="ps-map-popup-header">
            <span>Project Location</span>
            <button class="ps-map-popup-close" type="button" (click)="closeMapPopup()">
              <i class="ri-close-line"></i>
            </button>
          </div>
          <div #popupMap class="ps-map-popup-body"></div>
        </div>
      </div>
    }
  }

</div>
